import { createSelector } from 'reselect'

export const getProfileLoading = createSelector(
  state => Boolean(state && state.user && state.user.profile && state.user.profile.isLoading),
  isLoading => isLoading
)
